import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CustomButton, Footer } from 'src/app/components';
import { EymemoryRoutes } from 'src/app/navigation/routes';
import LocalImages from 'src/app/static';

const ForbiddenScreen = () => {
  const [searchParams] = useSearchParams();
  const orderHash = searchParams.get("orderHash");
  const navigate = useNavigate();

  return (
    <div className="main-wrapper bg-white container">
      <div className="d-flex flex-column flex-grow-1 mg-b-20 justify-content-center align-items-center">
          <img src={LocalImages.noDocumentFound} alt="file-empty" style={{ width: '80px' }} className='mg-b-15' />
         <p className="fs-5 fs-18 text-black fw-bold mg-b-5 text-center">
          This order is no longer available.
        </p>
        <p className="fs-14 text-black text-center mg-b-10">
          The file has been removed from our server as the access window has expired.
        </p>
        {orderHash && 
          <div className="mg-t-30 btn-back">
            <CustomButton
              text="Back"
              color="outline-primary"
              onClick={() =>
                navigate(
                  `${EymemoryRoutes.EYMEMORIES_DOWNLOAD_LINK}/${orderHash}`
                )
              }
            />
          </div>
        }
      </div>
      <div className="mg-b-10">
        <Footer />
      </div>
    </div>
  );
};

export default ForbiddenScreen;
